import { inject, InjectionToken } from '@angular/core';
import { submissionDetailSignalStore } from '../signal-stores';

import { SubmissionDetailSignalState } from '../../types';

export const SUBMISSION_DETAIL_TOKEN =
  new InjectionToken<SubmissionDetailSignalState>('Submission Detail Token');

export const SUBMISSION_DETAIL_PROVIDER = {
  provide: SUBMISSION_DETAIL_TOKEN,
  useClass: submissionDetailSignalStore,
};

export function submissionDetailTokenizer() {
  return inject(SUBMISSION_DETAIL_TOKEN);
}
